/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { icd10CodeIdGet } from '../fn/icd-10-code/icd-10-code-id-get';
import { Icd10CodeIdGet$Params } from '../fn/icd-10-code/icd-10-code-id-get';
import { icd10CodePost } from '../fn/icd-10-code/icd-10-code-post';
import { Icd10CodePost$Params } from '../fn/icd-10-code/icd-10-code-post';
import { Icd10CodeRecordModel } from '../models/icd-10-code-record-model';
import { Icd10CodeRecordModelSearchResultModel } from '../models/icd-10-code-record-model-search-result-model';
import { icd10CodeSearchIcd10CodePost } from '../fn/icd-10-code/icd-10-code-search-icd-10-code-post';
import { Icd10CodeSearchIcd10CodePost$Params } from '../fn/icd-10-code/icd-10-code-search-icd-10-code-post';

@Injectable({ providedIn: 'root' })
export class MDIIcd10CodeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `icd10CodeSearchIcd10CodePost()` */
  static readonly Icd10CodeSearchIcd10CodePostPath = '/ICD10Code/SearchICD10Code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `icd10CodeSearchIcd10CodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  icd10CodeSearchIcd10CodePost$Response(params?: Icd10CodeSearchIcd10CodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Icd10CodeRecordModelSearchResultModel>> {
    return icd10CodeSearchIcd10CodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `icd10CodeSearchIcd10CodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  icd10CodeSearchIcd10CodePost(params?: Icd10CodeSearchIcd10CodePost$Params, context?: HttpContext): Observable<Icd10CodeRecordModelSearchResultModel> {
    return this.icd10CodeSearchIcd10CodePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Icd10CodeRecordModelSearchResultModel>): Icd10CodeRecordModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `icd10CodeIdGet()` */
  static readonly Icd10CodeIdGetPath = '/ICD10Code/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `icd10CodeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  icd10CodeIdGet$Response(params: Icd10CodeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Icd10CodeRecordModel>> {
    return icd10CodeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `icd10CodeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  icd10CodeIdGet(params: Icd10CodeIdGet$Params, context?: HttpContext): Observable<Icd10CodeRecordModel> {
    return this.icd10CodeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Icd10CodeRecordModel>): Icd10CodeRecordModel => r.body)
    );
  }

  /** Path part for operation `icd10CodePost()` */
  static readonly Icd10CodePostPath = '/ICD10Code';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `icd10CodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  icd10CodePost$Response(params?: Icd10CodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return icd10CodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `icd10CodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  icd10CodePost(params?: Icd10CodePost$Params, context?: HttpContext): Observable<string> {
    return this.icd10CodePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
